import { useTheme } from '@mui/material'
import { useContextState } from '../../../../../../hooks/theme'

export const useStyles = () => {
  const { colors: color } = useContextState()
  const { breakpoints } = useTheme()
  return {
    container: {
      paddingTop: '40px',
      paddingRight: '40px',
      paddingLeft: '1px',
      paddingBottom: '15px',
      width: '100%',
      overflowY: 'auto',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom : '20px',
    },
    headerLeft: {
      display: 'flex',
      width: 'fit-content',
      alignItems: 'center',
      '& .MuiIconButton-root': {
        color: color.color4,
        fontWeight: '600',
        marginLeft:'-10px',
      },
      '& .MuiTypography-root': {
        fontSize: '17px',
        fontWeight: '400',
        color: color.color4,
      }
    },
    title: {
      flexGrow: 1,
      fontSize: '22px',
      fontWeight: '500',
    },
    stepper: {
      width: {xl: '500px', lg: 'min-content', md: 'min-content', sm: 'min-content'},
      [breakpoints.between(1450, 1700)]: {
        width: '500px'
      }
    },
    body: {
      margin: '20px 0',
      width: '100%',
      minHeight: '10rem',
      //boxShadow: `0 0 3px ${color.color13}`,
      //padding: '0 50px 10px',
    },
    buttonsContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .back': {
        width: '80px',
        height: '36px',
        /* textTransform: 'uppercase', */
      },
      '& .next': {
        borderRadius: '4px',
        /* textTransform: 'uppercase', */
      },
    },
  }
}
